import { HttpParams } from "@angular/common/http";

export interface Predicate {
	name: string;
	operand: string;
	value: string;
}

export class SpringQuery {

	predicates: Predicate[] = [];

	addEquals(name: string, value: string) {
		let predicate: Predicate = {
			name: name,
			operand: "",
			value: value
		};
		this.predicates.push(predicate);
	}

	getParams():HttpParams {
		let params = new HttpParams();

		for (let predicate of this.predicates) {
			params = params.append(predicate.name, predicate.value);
		}

		return params;
	}
}